import { useState, useEffect } from "react";

export default function AddressAutocomplete({ onChange }) {
  const [numero, setNumero] = useState("");
  const [rue, setRue] = useState("");
  const [codePostal, setCodePostal] = useState("");
  const [ville, setVille] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const fetchSuggestions = async () => {
    const queryParts = [];
    if (numero) queryParts.push(numero);
    if (rue) queryParts.push(rue);
    if (ville) queryParts.push(ville);
    if (codePostal) queryParts.push(codePostal);
    const query = encodeURIComponent(queryParts.join(" "));

    const url = `https://nominatim.openstreetmap.org/search?q=${query}&format=json&addressdetails=1&limit=5&countrycodes=fr`;
    try {
      const res = await fetch(url);
      const data = await res.json();
      setSuggestions(data);
      setShowSuggestions(true);
    } catch (err) {
      console.error("Erreur auto-complétion:", err);
    }
  };

  // Déclenche la recherche dès qu'on modifie numéro, rue, code postal ou ville
  useEffect(() => {
    if (rue || numero || ville || codePostal) {
      fetchSuggestions();
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  }, [numero, rue, ville, codePostal]);

  const handleSelect = (item) => {
    setNumero(item.address.house_number || numero);
    setRue(item.address.road || rue);
    setVille(item.address.city || item.address.town || item.address.village || ville);
    setCodePostal(item.address.postcode || codePostal);
    setShowSuggestions(false);
    setSuggestions([]);

    if (onChange) {
      onChange({
        numero: item.address.house_number || numero,
        rue: item.address.road || rue,
        ville: item.address.city || item.address.town || item.address.village || ville,
        codePostal: item.address.postcode || codePostal,
        lat: parseFloat(item.lat),
        lng: parseFloat(item.lon),
      });
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <input
        placeholder="Numéro"
        value={numero}
        onChange={(e) => setNumero(e.target.value)}
      />
      <input
        placeholder="Rue"
        value={rue}
        onChange={(e) => setRue(e.target.value)}
      />
      <input
        placeholder="Code postal"
        value={codePostal}
        onChange={(e) => setCodePostal(e.target.value)}
      />
      <input
        placeholder="Ville"
        value={ville}
        onChange={(e) => setVille(e.target.value)}
      />

      {showSuggestions && suggestions.length > 0 && (
        <ul style={{ position: "absolute", zIndex: 10, background: "white", width: "100%", maxHeight: 200, overflowY: "auto", border: "1px solid #ccc" }}>
          {suggestions.map((item, idx) => (
            <li
              key={idx}
              style={{ padding: "0.5rem", cursor: "pointer" }}
              onClick={() => handleSelect(item)}
            >
              {item.display_name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
